import { ExclamationCircleIcon } from '@heroicons/react/20/solid';
import type { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

/**
 * Soft red inline alert for surfacing a form-level error, introduced with the
 * sign-in redesign. Shared so every form can surface errors the same way (see
 * usage in the auth screens; roll out to other forms tracked separately). Pass
 * the message, and any inline links, as children.
 */
export default function FormAlert({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <span
      role="alert"
      className={twMerge(
        'mt-1 flex items-start gap-2 rounded-lg bg-red-50 px-3 py-2 text-red-700 text-xs leading-relaxed dark:bg-red-500/10 dark:text-red-300',
        className,
      )}
    >
      <ExclamationCircleIcon className="mt-px size-4 shrink-0 text-red-500 dark:text-red-400" />
      <span>{children}</span>
    </span>
  );
}
